import { Badge } from "@/components/ui/badge";
import { isWebEchoRecord, type WebEchoRecordFields } from "./webEcho";
import { webSurfaceLabel } from "./partnerDemo";

const WEB_ECHO_TITLE =
  "Made on my.echoflicks.com (web Create) — the Felix interview is in the Web transcript, not WhatsApp";

/**
 * 🌐 marker for an Echo made on my.echoflicks.com instead of a WhatsApp chat
 * (MYC-090). Like the 🧪 Test Echo badge, it renders nothing at all for an
 * ordinary WhatsApp Echo.
 *
 * Lists pass only the `record` (its `echo_channel` / `web_creation_id` marker);
 * the Echo page passes `isWeb`, which also counts the session's web events and
 * journey nodes (see webEcho.ts), so the badge shows even before the indexer
 * has stamped the ECHO row.
 */
export const WebEchoBadge = ({
  record,
  isWeb,
}: {
  record?: WebEchoRecordFields | null;
  isWeb?: boolean;
}) => {
  if (!(isWeb ?? isWebEchoRecord(record))) return null;
  const label = webSurfaceLabel(record);
  const title =
    label === "Web"
      ? WEB_ECHO_TITLE
      : `Made via ${label}. The Felix interview is in the Web transcript.`;

  return (
    <Badge
      variant="outline"
      title={title}
      aria-label={label === "Web" ? "Web Echo" : label}
    >
      🌐 {label}
    </Badge>
  );
};
